import type { JSONContent } from '@tiptap/core';
import {
  ChevronCircleDownRegular,
  FluentIcon,
  TextDescriptionRegular,
  TextFieldRegular,
  TextHeader2Regular,
  TextParagraphRegular,
} from '@fluentui/react-icons';

import {
  TEMPLATE_FIELD_BLOCK_NAME,
  TEMPLATE_FIELD_DROPDOWN_NAME,
  TEMPLATE_FIELD_INLINE_NAME,
} from '../../doc-engine/templateFields';
import { ETiptapSelectorKey } from '../../types/tiptap.types';

export type TInsertItem = {
  title: string;
  icon: FluentIcon;
};

type TFormFieldItem = TInsertItem & { fieldName: string };

type TTextBlockItem = TInsertItem & { block: JSONContent };

/** The field kinds a form offers, in the order every menu shows them. */
export const FORM_FIELD_ITEMS: TFormFieldItem[] = [
  {
    fieldName: TEMPLATE_FIELD_INLINE_NAME,
    title: 'Inline text',
    icon: TextFieldRegular,
  },
  {
    fieldName: TEMPLATE_FIELD_BLOCK_NAME,
    title: 'Content text',
    icon: TextDescriptionRegular,
  },
  {
    fieldName: TEMPLATE_FIELD_DROPDOWN_NAME,
    title: 'Dropdown',
    icon: ChevronCircleDownRegular,
  },
];

/** The field kinds that can sit in a paragraph; Content text is a block. */
export const PARAGRAPH_FIELD_ITEMS = FORM_FIELD_ITEMS.filter(
  ({ fieldName }) => fieldName !== TEMPLATE_FIELD_BLOCK_NAME
);

/** The text a form is written around, which a block's + also adds. */
export const TEXT_BLOCK_ITEMS: TTextBlockItem[] = [
  {
    block: { type: ETiptapSelectorKey.HEADING, attrs: { level: 2 } },
    title: 'Heading',
    icon: TextHeader2Regular,
  },
  {
    block: { type: ETiptapSelectorKey.PARAGRAPH },
    title: 'Paragraph',
    icon: TextParagraphRegular,
  },
];

// A card's label row, from the card's top.
export const GUTTER_CARD_LABEL_OFFSET_PX = 10;
// The tallest first line the margin buttons centre on.
export const GUTTER_FIRST_LINE_MAX_PX = 36;
// A small Fluent button's height.
export const GUTTER_BUTTON_HEIGHT_PX = 28;
// How far left of a block's text the margin buttons start: room for the + and the handle, and a gap.
export const GUTTER_LEFT_OFFSET_PX = 56;
